'use client'

import { FC } from 'react'
import styles from './Hero.module.scss'
import { HeroProps } from './Hero.types'
import { Type } from 'components/Type'
import { Button } from 'components/Phantom/Button'
import { Img } from 'components/basic/Img'
import { AffirmLogoPurpleBlackText } from 'components/_const_assets/affirmLogo'
import { KlarnaLogo } from 'components/_const_assets/klarnaLogo'
import { useFinancingProvider, usePod4Prices } from 'stores/prices'
import { notFound } from 'next/navigation'
import { TruemedBlueLogo } from 'components/_const_assets/truemedLogo'

export const Hero: FC<HeroProps> = () => {
	const { monthlyPriceFormatted, klarnaMonthlyPriceFormatted } = usePod4Prices()
	const financingProvider = useFinancingProvider()

	const financingPriceFormatted = financingProvider === 'affirm' ? monthlyPriceFormatted : klarnaMonthlyPriceFormatted

	if (financingProvider === 'none') {
		notFound()
	}

	const financingProviderLogo = financingProvider === 'affirm' ? <AffirmLogoPurpleBlackText /> : <KlarnaLogo />

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<header data-financing-provider={financingProvider}>
					<Type.Headline2 as="h1">
						Pay over time. Get the Pod for as low as {financingPriceFormatted}/month with {financingProviderLogo}
					</Type.Headline2>
					<Button.Dark id="hero-cta">Prequalify now</Button.Dark>
					<Type.SmallPrint className={styles.small_print}>Prequalify without affecting your credit</Type.SmallPrint>
				</header>

				<div className={styles.image_container}>
					<Img
						src="https://res.cloudinary.com/eightsleep/image/upload/risk-free-boxing-day_qzrq8w.jpg"
						alt="Hero image"
						objectFit="cover"
					/>
				</div>
			</div>
		</div>
	)
}

export const TruemedHero: FC = () => {
	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<header data-financing-provider="truemed">
					<Type.Headline2 as="h1">Save an average of 30% with FSA/HSA</Type.Headline2>
					<Type.Headchapter>
						The Pod is FSA/HSA eligible with <TruemedBlueLogo color="black" />
					</Type.Headchapter>
				</header>

				<div className={styles.image_container}>
					<Img
						src="https://res.cloudinary.com/eightsleep/image/upload/8Sleep_New_York_RENDER_C2.jpg"
						alt="Hero image"
						objectFit="cover"
					/>
				</div>
			</div>
		</div>
	)
}
